import { type ConfigurationOptions } from '../../common/types';
import { appendQueryParams } from '../../common/utils/appendQueryParams';
import { convertToSameOrigin } from '../../common/utils/convertToSameOrigin';

export class IFrameManager {
	private iframe: HTMLIFrameElement | null = null;
	private iframeURL: URL;
	private iframeTitle?: string;

	constructor(
		href: string,
		configurationOptions?: ConfigurationOptions,
		useFullUrl?: boolean,
		title?: string,
	) {
		const url = useFullUrl ? new URL(href) : convertToSameOrigin(href);

		this.iframeURL = appendQueryParams(url, configurationOptions);
		this.iframeTitle = title;
	}

	get origin(): string {
		return this.iframeURL.origin;
	}

	create(container: HTMLElement): HTMLIFrameElement {
		this.iframe = document.createElement('iframe');
		this.iframe.src = this.iframeURL.href;
		if (this.iframeTitle) {
			this.iframe.title = this.iframeTitle;
		}

		this.iframe.style.border = '0px';
		this.iframe.style.minWidth = '100%';
		this.iframe.style.height = '100%';

		container.appendChild(this.iframe);

		return this.iframe;
	}

	remove(): void {
		if (this.iframe && this.iframe.parentElement) {
			this.iframe.parentElement.removeChild(this.iframe);
			this.iframe = null;
		}
	}
}
